module.exports = __webpack_public_path__ + "static/media/logobig2.0a5d297a.png";